/**
 * Params for `getAccessTokenSilently` — must stay aligned with
 * `authorizationParams` on `Auth0Provider` (`Auth0ProviderWithNavigate.jsx`).
 * Mismatched audience/scope can contribute to "Missing Refresh Token" cache lookups.
 */
export function getAuth0TokenAuthorizationParams() {
  return {
    audience: import.meta.env.VITE_AUTH0_AUDIENCE || undefined,
    scope:
      import.meta.env.VITE_AUTH0_SCOPE || 'openid profile email offline_access',
  };
}
